var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _g2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g3, _path49, _g4, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g5, _path68, _g6, _path69, _g7, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g8, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _g9, _path98, _g10, _path99, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup10189(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 120,
    viewBox: "0 0 1440 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 120,
    fill: "#8255FF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_534_18302)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 120,
    fill: "#E6E9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1078.07 -120.482L1138.31 -60.2393H1017.82L1078.07 -120.482Z",
    fill: "#F2F4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.31 -60.2383L1198.55 0.00439015H1078.07L1138.31 -60.2383Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.55 0.00366211L1258.8 60.2464H1138.31L1198.55 0.00366211Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.07 0.00372314L1138.31 -60.239L1017.82 -60.239L1078.07 0.00372314Z",
    fill: "#ECEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.55 120.488L1258.8 60.2451L1138.31 60.2451L1198.55 120.488Z",
    fill: "#ECEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.55 -120.482L1258.8 -60.2391H1138.31L1198.55 -120.482Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.79 -60.2383L1319.03 0.00439015H1198.55L1258.79 -60.2383Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.55 0.00366211L1258.8 -60.2391L1138.31 -60.2391L1198.55 0.00366211Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.79 60.2458L1319.03 0.00302055L1198.55 0.0030307L1258.79 60.2458Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M957.581 -120.482L1017.82 -60.2391H897.338L957.581 -120.482Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M897.343 -60.2382L957.586 0.00451222H837.101L897.343 -60.2382Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M897.343 59.8949L957.586 120.138H837.101L897.343 59.8949Z",
    fill: "#FAFBFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.82 -60.2383L1078.07 0.00439015H957.581L1017.82 -60.2383Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M957.581 0.00372314L1017.82 60.2465H897.338L957.581 0.00372314Z",
    fill: "#FAFBFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.07 0.00378418L1138.31 60.2465H1017.83L1078.07 0.00378418Z",
    fill: "#ECEEF9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.07 120.489L1138.31 60.2466H1017.83L1078.07 120.489Z",
    fill: "#ECEEF9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.82 60.2457L1078.07 120.488H957.581L1017.82 60.2457Z",
    fill: "#F2F4FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.31 60.2457L1198.55 120.488H1078.07L1138.31 60.2457Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M897.343 60.2457L957.586 0.00299003L837.101 0.00300018L897.343 60.2457Z",
    fill: "#E6E9F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.82 60.2457L1078.07 0.00295951L957.581 0.00296967L1017.82 60.2457Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 957,
    y: 0,
    width: 122,
    height: 61
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.82 60.2472L1078.07 0.00442435L957.581 0.00443451L1017.82 60.2472Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_534_18302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1019.64,
    y: 59.6465,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1019.64 59.6465)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1022.05,
    y: 57.2369,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1022.05 57.2369)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.46,
    y: 54.8259,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1024.46 54.8259)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1026.86,
    y: 52.4164,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1026.86 52.4164)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1029.27,
    y: 50.0069,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1029.27 50.0069)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1031.68,
    y: 47.5974,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1031.68 47.5974)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1034.09,
    y: 45.1879,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1034.09 45.1879)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1036.5,
    y: 42.7784,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1036.5 42.7784)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1038.91,
    y: 40.3689,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1038.91 40.3689)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1041.32,
    y: 37.9579,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1041.32 37.9579)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1043.73,
    y: 35.5484,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1043.73 35.5484)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1046.14,
    y: 33.1389,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1046.14 33.1389)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1048.55,
    y: 30.7294,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1048.55 30.7294)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1050.95,
    y: 28.3199,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1050.95 28.3199)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1053.37,
    y: 25.9104,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1053.37 25.9104)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1055.78,
    y: 23.4993,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1055.78 23.4993)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1058.19,
    y: 21.0899,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1058.19 21.0899)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1060.6,
    y: 18.6804,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1060.6 18.6804)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063.01,
    y: 16.2708,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1063.01 16.2708)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1065.41,
    y: 13.8629,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1065.41 13.8629)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1067.82,
    y: 11.4519,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1067.82 11.4519)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1070.23,
    y: 9.04395,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1070.23 9.04395)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1072.64,
    y: 6.63132,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1072.64 6.63132)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1075.06,
    y: 4.22339,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1075.06 4.22339)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1077.47,
    y: 1.81232,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 1077.47 1.81232)",
    fill: "#ECEEF9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1078,
    y: 60,
    width: 121,
    height: 61
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.31 60.2458L1078.07 120.489L1198.55 120.489L1138.31 60.2458Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_534_18302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1136.5,
    y: 60.8466,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1136.5 60.8466)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134.09,
    y: 63.256,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1134.09 63.256)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1131.68,
    y: 65.6671,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1131.68 65.6671)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1129.28,
    y: 68.0766,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1129.28 68.0766)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1126.87,
    y: 70.4861,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1126.87 70.4861)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1124.46,
    y: 72.8956,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1124.46 72.8956)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1122.04,
    y: 75.3051,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1122.04 75.3051)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1119.63,
    y: 77.7146,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1119.63 77.7146)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.22,
    y: 80.124,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1117.22 80.124)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1114.81,
    y: 82.5351,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1114.81 82.5351)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1112.4,
    y: 84.9446,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1112.4 84.9446)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1110,
    y: 87.3541,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1110 87.3541)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1107.59,
    y: 89.7636,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1107.59 89.7636)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1105.18,
    y: 92.1731,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1105.18 92.1731)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1102.76,
    y: 94.5826,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1102.76 94.5826)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100.36,
    y: 96.9937,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1100.36 96.9937)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1097.95,
    y: 99.4031,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1097.95 99.4031)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1095.54,
    y: 101.813,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1095.54 101.813)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1093.13,
    y: 104.222,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1093.13 104.222)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.72,
    y: 106.63,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1090.72 106.63)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.31,
    y: 109.041,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1088.31 109.041)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1085.9,
    y: 111.449,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1085.9 111.449)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1083.5,
    y: 113.862,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1083.5 113.862)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1081.08,
    y: 116.27,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1081.08 116.27)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.66,
    y: 118.681,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(-45 1078.66 118.681)",
    fill: "#ECEEF9"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M957.581 120.488L1017.82 60.2451L897.338 60.2451L957.581 120.488Z",
    fill: "#FAFBFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.82 180.733L1078.07 120.49L957.581 120.49L1017.82 180.733Z",
    fill: "#ECEEF9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.31 180.733L1198.55 120.49L1078.07 120.49L1138.31 180.733Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M596.068 -120.482L656.31 -60.2393H535.825L596.068 -120.482Z",
    fill: "#F2F4FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M656.311 -60.2383L716.554 0.00439015H596.069L656.311 -60.2383Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M716.555 0.00366211L776.797 60.2464H656.312L716.555 0.00366211Z",
    fill: "#F2F4FC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M776.792 60L837.034 120.243H716.549L776.792 60Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M596.068 0.00372314L656.31 -60.239L535.825 -60.239L596.068 0.00372314Z",
    fill: "#ECEEF9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M716.555 120.488L776.798 60.2451L656.312 60.2451L716.555 120.488Z",
    fill: "#ECEEF9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M716.555 -120.482L776.798 -60.2391H656.312L716.555 -120.482Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M776.792 -60.2383L837.035 0.00439015H716.549L776.792 -60.2383Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M716.555 0.00366211L776.797 -60.2391L656.312 -60.2391L716.555 0.00366211Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M776.792 60.2458L837.035 0.00302055L716.549 0.0030307L776.792 60.2458Z",
    fill: "#FAFBFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M475.581 -120.482L535.824 -60.2391H415.338L475.581 -120.482Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M415.343 -60.2382L475.586 0.00451222H355.101L415.343 -60.2382Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M535.824 -60.2383L596.067 0.00439015H475.581L535.824 -60.2383Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M475.581 0.00372314L535.824 60.2465H415.338L475.581 0.00372314Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M416.243 60L476.485 120.243H356L416.243 60Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M596.068 0.00378418L656.311 60.2465H535.825L596.068 0.00378418Z",
    fill: "#FAFBFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M596.068 120.489L656.311 60.2466H535.825L596.068 120.489Z",
    fill: "#FAFBFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M656.243 60.4855L716.485 0.242741H596L656.243 60.4855Z",
    fill: "#FAFBFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M535.824 60.2457L596.067 120.488H475.581L535.824 60.2457Z",
    fill: "#FAFBFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M656.311 60.2457L716.554 120.488H596.069L656.311 60.2457Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M415.343 60.2457L475.586 0.00299003L355.101 0.00300018L415.343 60.2457Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M535.824 60.2457L596.067 0.00295951L475.581 0.00296967L535.824 60.2457Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 475,
    y: 0,
    width: 122,
    height: 61
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M535.824 60.2472L596.067 0.00442435L475.581 0.00443451L535.824 60.2472Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_534_18302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.637,
    y: 59.6465,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 537.637 59.6465)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.047,
    y: 57.2369,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 540.047 57.2369)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.457,
    y: 54.8259,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 542.457 54.8259)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.86,
    y: 52.4164,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 544.86 52.4164)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.269,
    y: 50.0069,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 547.269 50.0069)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.679,
    y: 47.5974,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 549.679 47.5974)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.095,
    y: 45.1879,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 552.095 45.1879)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 554.504,
    y: 42.7784,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 554.504 42.7784)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556.914,
    y: 40.3689,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 556.914 40.3689)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.323,
    y: 37.9579,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 559.323 37.9579)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.733,
    y: 35.5484,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 561.733 35.5484)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.136,
    y: 33.1389,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 564.136 33.1389)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.545,
    y: 30.7294,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 566.545 30.7294)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 568.955,
    y: 28.3199,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 568.955 28.3199)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.371,
    y: 25.9104,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 571.371 25.9104)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.78,
    y: 23.4993,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 573.78 23.4993)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.189,
    y: 21.0899,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 576.189 21.0899)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.599,
    y: 18.6804,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 578.599 18.6804)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.009,
    y: 16.2708,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 581.009 16.2708)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.412,
    y: 13.8629,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 583.412 13.8629)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.821,
    y: 11.4519,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 585.821 11.4519)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.231,
    y: 9.04395,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 588.231 9.04395)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.64,
    y: 6.63132,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 590.64 6.63132)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.056,
    y: 4.22339,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 593.056 4.22339)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.472,
    y: 1.81232,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 595.472 1.81232)",
    fill: "#ECEEF9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 596,
    y: 60,
    width: 121,
    height: 61
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M656.311 60.2458L716.554 120.489L596.069 120.489L656.311 60.2458Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_534_18302)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 658.125 60.8466)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 660.534 63.256)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 662.944 65.6671)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 665.347 68.0766)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 667.756 70.4861)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 670.166 72.8956)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 672.582 75.3051)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 674.991 77.7146)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 677.4 80.124)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 679.81 82.5351)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 682.219 84.9446)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 684.623 87.3541)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 687.032 89.7636)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 689.442 92.1731)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 691.858 94.5826)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 694.267 96.9937)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 696.677 99.4031)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 699.086 101.813)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 701.496 104.222)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 703.899 106.63)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 706.308 109.041)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 708.718 111.449)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 711.127 113.862)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 713.543 116.27)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 715.958 118.681)",
    fill: "#ECEEF9"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M475.581 120.488L535.824 60.2451L415.338 60.2451L475.581 120.488Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M535.824 180.733L596.067 120.49L475.581 120.49L535.824 180.733Z",
    fill: "#ECEEF9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M656.311 180.733L716.554 120.49L596.069 120.49L656.311 180.733Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.824 -60.7241L235.067 -0.481328H114.582L174.824 -60.7241Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M235.068 -0.4823L295.311 59.7604H174.825L235.068 -0.4823Z",
    fill: "#FAFBFF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M174.824 59.7614L235.067 -0.481293L114.582 -0.481283L174.824 59.7614Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M235.068 120.003L295.311 59.7607L174.825 59.7608L235.068 120.003Z",
    fill: "#ECEEF9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M295.312 -60.7241L355.554 -0.481328H235.069L295.312 -60.7241Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M295.312 59.7614L355.554 -0.481293L235.069 -0.481283L295.312 59.7614Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M355.555 120.003L415.798 59.7607L295.312 59.7607L355.555 120.003Z",
    fill: "#ECEEF9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M415.792 180.246L476.035 120.003L355.549 120.003L415.792 180.246Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M114.581 -0.482117L174.824 59.7606H54.3381L114.581 -0.482117Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3435 59.7615L114.586 120.004H-5.89923L54.3435 59.7615Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M174.824 59.7614L235.067 120.004H114.582L174.824 59.7614Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M114.581 119.941L174.824 59.6987H54.3381L114.581 119.941Z",
    fill: "#FAFBFF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3435 180.246L114.586 120.003L-5.89923 120.003L54.3435 180.246Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M174.824 180.245L235.067 120.003L114.582 120.003L174.824 180.245Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 120,
    width: 122,
    height: 61
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M174.824 180.247L235.067 120.004L114.582 120.004L174.824 180.247Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_534_18302)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: -61,
    width: 122,
    height: 61
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M174.824 -60.7255L114.582 -0.482726L235.067 -0.482737L174.824 -60.7255Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_534_18302)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 235,
    y: -1,
    width: 121,
    height: 61
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M295.312 59.7614L355.554 -0.481354L235.069 -0.481344L295.312 59.7614Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_534_18302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.125,
    y: 59.1607,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 297.125 59.1607)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.534,
    y: 56.7513,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 299.534 56.7513)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.944,
    y: 54.3402,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 301.944 54.3402)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.347,
    y: 51.9307,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 304.347 51.9307)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.757,
    y: 49.5212,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 306.757 49.5212)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.166,
    y: 47.1117,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 309.166 47.1117)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.582,
    y: 44.7022,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 311.582 44.7022)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.991,
    y: 42.2927,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 313.991 42.2927)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.401,
    y: 39.8832,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 316.401 39.8832)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.81,
    y: 37.4722,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 318.81 37.4722)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.22,
    y: 35.0627,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 321.22 35.0627)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.623,
    y: 32.6532,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 323.623 32.6532)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.033,
    y: 30.2437,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 326.033 30.2437)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.442,
    y: 27.8342,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 328.442 27.8342)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.858,
    y: 25.4247,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 330.858 25.4247)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.267,
    y: 23.0136,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 333.267 23.0136)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.677,
    y: 20.6041,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 335.677 20.6041)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.086,
    y: 18.1947,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 338.086 18.1947)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.496,
    y: 15.7852,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 340.496 15.7852)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.899,
    y: 13.3772,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 342.899 13.3772)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.309,
    y: 10.9662,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 345.309 10.9662)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.719,
    y: 8.55817,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 347.719 8.55817)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.127,
    y: 6.1456,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 350.127 6.1456)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.543,
    y: 3.73767,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 352.543 3.73767)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.959,
    y: 1.3266,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 354.959 1.3266)",
    fill: "#ECEEF9"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.93237 -0.482056L54.3104 59.7607H-66.1751L-5.93237 -0.482056Z",
    fill: "#F2F4FC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3113 59.7617L114.554 120.004H-5.93145L54.3113 59.7617Z",
    fill: "#ECEEF9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.93237 120.004L54.3104 59.761L-66.1751 59.761L-5.93237 120.004Z",
    fill: "#ECEEF9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3113 -60.7239L114.554 -0.481145H-5.93145L54.3113 -60.7239Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M114.555 -0.481873L174.798 59.7609H54.3122L114.555 -0.481873Z",
    fill: "#ECEEF9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M174.792 59.7617L235.035 120.004H114.549L174.792 59.7617Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3113 59.7617L114.554 -0.48108L-5.93146 -0.48107L54.3113 59.7617Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M114.555 120.004L174.797 59.7609L54.3119 59.7609L114.555 120.004Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M174.792 180.246L235.035 120.003L114.549 120.003L174.792 180.246Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: -1,
    width: 121,
    height: 61
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3113 59.7616L114.554 -0.481171L-5.93146 -0.481161L54.3113 59.7616Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_534_18302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.1245,
    y: 59.1609,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 56.1245 59.1609)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5342,
    y: 56.7515,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 58.5342 56.7515)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.9438,
    y: 54.3404,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 60.9438 54.3404)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.3472,
    y: 51.9308,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 63.3472 51.9308)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.7563,
    y: 49.5214,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 65.7563 49.5214)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.1658,
    y: 47.1119,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 68.1658 47.1119)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.5815,
    y: 44.7024,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 70.5815 44.7024)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.9912,
    y: 42.2929,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 72.9912 42.2929)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.4009,
    y: 39.8834,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 75.4009 39.8834)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.8101,
    y: 37.4724,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 77.8101 37.4724)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.2195,
    y: 35.0629,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 80.2195 35.0629)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.6228,
    y: 32.6534,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 82.6228 32.6534)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.0325,
    y: 30.2438,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 85.0325 30.2438)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.4419,
    y: 27.8344,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 87.4419 27.8344)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.8574,
    y: 25.4249,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 89.8574 25.4249)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.2671,
    y: 23.0138,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 92.2671 23.0138)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.6768,
    y: 20.6043,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 94.6768 20.6043)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.0862,
    y: 18.1949,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 97.0862 18.1949)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.4954,
    y: 15.7853,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 99.4954 15.7853)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.899,
    y: 13.3774,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 101.899 13.3774)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.308,
    y: 10.9663,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 104.308 10.9663)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.718,
    y: 8.55835,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 106.718 8.55835)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.127,
    y: 6.14578,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 109.127 6.14578)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.543,
    y: 3.73785,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 111.543 3.73785)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.959,
    y: 1.32678,
    width: 1.70392,
    height: 89.4559,
    transform: "rotate(135 113.959 1.32678)",
    fill: "#ECEEF9"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.82 -60.2836L1319.07 -0.0408369H1198.58L1258.82 -60.2836Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.07 -0.041748L1379.31 60.201H1258.83L1319.07 -0.041748Z",
    fill: "#ECEEF9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.31 60.202L1439.55 120.445H1319.07L1379.31 60.202Z",
    fill: "#F2F4FC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.82 60.202L1319.07 -0.0407722L1198.58 -0.040762L1258.82 60.202Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1319.07 120.444L1379.31 60.2013L1258.83 60.2013L1319.07 120.444Z",
    fill: "#F2F4FC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.31 -60.2836L1439.55 -0.0408369H1319.07L1379.31 -60.2836Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.56 -0.0415649L1499.8 60.2012H1379.31L1439.56 -0.0415649Z",
    fill: "#F2F4FC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.79 60.202L1560.04 120.445H1439.55L1499.79 60.202Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.31 60.202L1439.55 -0.0407722L1319.07 -0.040762L1379.31 60.202Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.55 120.444L1499.8 60.2012L1379.31 60.2012L1439.55 120.444Z",
    fill: "#F2F4FC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1499.79 180.686L1560.04 120.443L1439.55 120.443L1499.79 180.686Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.58 -0.0415649L1258.82 60.2012H1138.34L1198.58 -0.0415649Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.34 60.2021L1198.59 120.445H1078.1L1138.34 60.2021Z",
    fill: "#ECEEF9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.82 60.202L1319.07 120.445H1198.58L1258.82 60.202Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.58 120.382L1258.82 60.1392H1138.34L1198.58 120.382Z",
    fill: "#FAFBFF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.34 180.686L1198.59 120.443L1078.1 120.443L1138.34 180.686Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.82 180.686L1319.07 120.443L1198.58 120.443L1258.82 180.686Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1198,
    y: 120,
    width: 122,
    height: 61
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.82 180.687L1319.07 120.445L1198.58 120.445L1258.82 180.687Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_534_18302)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1198,
    y: -61,
    width: 122,
    height: 61
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.82 -60.285L1198.58 -0.0422356L1319.07 -0.0422458L1258.82 -60.285Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_534_18302)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_534_18302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1319,
    y: -1,
    width: 121,
    height: 62
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.31 60.2019L1319.07 -0.0408637L1439.55 -0.0408536L1379.31 60.2019Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_534_18302)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1377.5 59.6012)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1375.09 57.1918)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1372.68 54.7807)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1370.28 52.3712)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1367.87 49.9617)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1365.46 47.5522)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1363.04 45.1427)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1360.63 42.7332)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1358.22 40.3237)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1355.81 37.9127)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1353.4 35.5032)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1351 33.0937)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1348.59 30.6841)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1346.18 28.2747)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1343.77 25.8652)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1341.36 23.4541)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1338.95 21.0446)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1336.54 18.6352)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1334.13 16.2256)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1331.72 13.8177)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1329.31 11.4066)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1326.9 8.99866)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1324.5 6.58609)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1322.08 4.17816)",
    fill: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.70392,
    height: 89.4559,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1319.66 1.76709)",
    fill: "#ECEEF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup10189);
export default __webpack_public_path__ + "static/media/Group 10189.f4bb9a3a4f79e18c58907069ffa43d04.svg";
export { ForwardRef as ReactComponent };